import React from 'react'
import { IconCheck } from '../../../../shared/components/icons/IconCheck'
import { useTranslation } from 'react-i18next'
import { Badge } from '../../../../lib/ui/badge/component/badge/Badge'
import { Tooltip } from 'antd'
import { usePostTmInfringementsWhitelistMutation } from '../../../../app/api'
import { TComplaintStatus } from '../../model/types/ComplaintStatus.type'

interface CountryCellProps {
  project: number
  is_whitelisted: boolean
  has_repeat_history: boolean
  complaint_status: TComplaintStatus
  domain: string
}

export const DomainCell = ({
  project,
  is_whitelisted,
  has_repeat_history,
  complaint_status,
  domain,
}: CountryCellProps) => {
  const { t } = useTranslation()
  const [setWhitelist] = usePostTmInfringementsWhitelistMutation()

  return (
    <div className={'flex flex-col gap-[4px]'}>
      <div className={'h-[30px]'}>
        <a
          className={'text-[#0E63D8]'}
          href={`https://${domain}`}
          rel='noreferrer'
          target={'_blank'}
        >
          {domain}
        </a>
      </div>
      <div className={'flex gap-[4px]'}>
        {/* вернувшееся объявление уводит строку в To submit, у Disappeared в Resolved REPEAT не бывает */}
        {has_repeat_history && complaint_status !== 'disappeared' && (
          <Tooltip
            placement={'bottomRight'}
            title={t('pages.trademarkInfringements.repeatTooltip')}
          >
            <div className={'flex'}>
              <Badge>{t('pages.trademarkInfringements.repeat')}</Badge>
            </div>
          </Tooltip>
        )}
        {is_whitelisted ? (
          <button
            className={
              'row-hover-visible flex w-fit cursor-pointer items-center gap-[4px] whitespace-nowrap text-[12px] leading-[16px] text-focus'
            }
            onClick={() => {
              setWhitelist({
                body: {
                  project_id: project as unknown as number,
                  domain: domain as unknown as string[],
                  is_whitelisted: false,
                },
              })
            }}
          >
            <IconCheck className={'w-[10px]'} color={'#0E63D8'} />
            {t('pages.trademarkInfringements.removeFromWhitelist')}
          </button>
        ) : (
          <button
            className={
              'row-hover-visible flex w-fit cursor-pointer items-center gap-[4px] whitespace-nowrap text-[12px] leading-[16px] text-focus'
            }
            onClick={() => {
              setWhitelist({
                body: {
                  project_id: project as unknown as number,
                  domain: domain as unknown as string[],
                  is_whitelisted: true,
                },
              })
            }}
          >
            <IconCheck className={'w-[10px]'} color={'#0E63D8'} />
            {t('pages.trademarkInfringements.addToWhitelist')}
          </button>
        )}
      </div>
    </div>
  )
}
